import { render, staticRenderFns } from "./AccountingExportConfig.vue?vue&type=template&id=36f4f05a&"
import script from "./AccountingExportConfig.vue?vue&type=script&lang=js&"
export * from "./AccountingExportConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports